import { useQuery } from "@tanstack/react-query";
import { APIErrorResponse, IGenericPagination } from "src/types/generic";
import { ICustomer } from "src/types/customers";
import apiFastifyClient from "../apiFastifyCloud";

interface IParams {
  page?: number;
  limit?: number;
  search?: string;
  plateType?: string;
  gender?: string;
  brandId?: string;
  vehiclesCount?: number;
  isInternal?: boolean;
  visitRanges?: string[]
}

export interface IVisitRangeOptions {
  min: number;
  max: number;
  label: string;
}

export const useGetCustomersList = (params: IParams) =>
  useQuery<
    void,
    APIErrorResponse,
    {
      data: ICustomer[];
      meta: IGenericPagination;
      vehicleCountOptions: number[];
      visitRangeOptions: IVisitRangeOptions[];
    }
  >({
    queryKey: [
      "get-customers-list",
      params.page,
      params.limit,
      params.search,
      params.plateType,
      params.brandId,
      params.gender,
      params.vehiclesCount,
      params.visitRanges,
      params.isInternal,
    ],
    queryFn: async () => {
      return apiFastifyClient.get(`/v1/customers`, { params });
    },
    gcTime: 30 * 60 * 1000,
  });
